import React, { FC, memo } from 'react'
import styled from 'styled-components'
import SC from '../base/InlineForm.styles'
import { IInlineFormProps } from '../types'
import { Button } from '../../Button/desktop'

const { Block, Control: ControlSC, Action: ActionSC } = SC

const Action = styled(ActionSC)`
  button {
    margin-left: -1px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`

const Control = styled(ControlSC)`
  fieldset {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`

/** Инлайн форма */
const InlineForm: FC<IInlineFormProps> = (props) => {
  const { buttonText = 'Найти', onClick, control, ...otherProps } = props

  return (
    <Block {...otherProps}>
      <Control>{control}</Control>

      <Action>
        <Button type='submit' onClick={onClick} color='blue'>
          {buttonText}
        </Button>
      </Action>
    </Block>
  )
}

export { InlineForm }
export default memo(InlineForm)
